module.exports = __webpack_public_path__ + "img/cxTrends-14.c0306f17.png";